(function () {
  var current = null, selected = [], busy = false, closing = false;

  var css = '' +
    '.qa{position:fixed;inset:0;z-index:9999;display:flex;align-items:flex-end;justify-content:center;visibility:hidden;pointer-events:none}' +
    '.qa.is-open{visibility:visible;pointer-events:auto}' +
    '.qa__overlay{position:absolute;inset:0;background:rgba(0,0,0,.4);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;transition:opacity .3s ease}' +
    '.qa.is-open .qa__overlay{opacity:1;display:block;}' +
    '.qa__sheet{position:relative;width:100%;max-width:520px;background:#fff;border-radius:24px 24px 0 0;padding:14px 20px calc(24px + env(safe-area-inset-bottom));max-height:88vh;overflow:auto;-webkit-overflow-scrolling:touch;' +
      'transform:translateY(100%);transition:transform .38s cubic-bezier(.32,.72,0,1);will-change:transform;touch-action:pan-y}' +
    '.qa.is-open .qa__sheet{transform:translateY(0)}' +
    '.qa__sheet.is-dragging{transition:none}' +
    '.qa__handle{width:42px;height:4px;border-radius:4px;background:#d6d6d6;margin:0 auto 14px}' +
    '.qa__close{position:absolute;top:16px;right:16px;width:34px;height:34px;border:0;border-radius:50%;background:#f0f0f0;color:#333;font-size:20px;line-height:1;cursor:pointer;transition:background .2s,transform .2s}' +
    '.qa__close:hover{background:#e2e2e2;transform:rotate(90deg)}' +
    '.qa__head{display:flex;align-items:center;gap:16px;margin:6px 0 18px;padding-right:44px}' +
    '.qa__imgwrap{width:76px;height:76px;flex:none;border-radius:12px;background:#f5f5f5;overflow:hidden}' +
    '.qa__imgwrap img{width:100%;height:100%;object-fit:contain;display:block;transition:opacity .25s ease}' +
    '.qa__imgwrap img.is-fade{opacity:0}' +
    '.qa__head h3{margin:0;font-size:17px;line-height:1.3;text-transform:uppercase;letter-spacing:.02em}' +
    '.qa__opt{margin-top:14px}.qa__opt p{margin:0 0 10px;font-size:15px}' +
    '.qa__vals{display:flex;flex-wrap:wrap;gap:10px}' +
    '.qa__val{min-width:42px;height:42px;padding:0 14px;border:1px solid #d5d5d5;border-radius:21px;background:#fff;cursor:pointer;font-size:14px;transition:border-color .2s,transform .15s,box-shadow .2s}' +
    '.qa__val:hover{border-color:#999}.qa__val:active{transform:scale(.94)}' +
    '.qa__val.is-img{width:42px;padding:0;border-radius:50%;overflow:hidden}' +
    '.qa__val.is-img img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.qa__val.is-active{border-color:#1a1a1a;box-shadow:0 0 0 2px #fff,0 0 0 4px #1a1a1a}' +
    '.qa__val.is-out{opacity:.4}' +
    '.qa__buy{position:relative;width:100%;margin-top:24px;height:54px;border:0;border-radius:27px;background:#2b1612;color:#fff;font-size:15px;letter-spacing:.05em;cursor:pointer;overflow:hidden;transition:background .25s,transform .15s,opacity .2s}' +
    '.qa__buy:active{transform:scale(.98)}.qa__buy:disabled{opacity:.5;cursor:default}' +
    '.qa__buy.is-loading{pointer-events:none;color:transparent}' +
    '.qa__buy.is-loading::after{content:"";position:absolute;left:50%;top:50%;width:20px;height:20px;margin:-10px 0 0 -10px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:qaspin .7s linear infinite}' +
    '.qa__buy.is-done{background:#2a1613;pointer-events:none}' +
    '@keyframes qaspin{to{transform:rotate(360deg)}}' +
    '@media(min-width:750px){' +
      '.qa{align-items:center}' +
      '.qa__handle{display:none}' +
      '.qa__sheet{border-radius:24px;padding:28px 28px 28px;transform:translateY(14px) scale(.96);opacity:0;transition:transform .32s cubic-bezier(.32,.72,0,1),opacity .25s ease}' +
      '.qa.is-open .qa__sheet{transform:none;opacity:1}' +
    '}' +
    '@media(prefers-reduced-motion:reduce){.qa__sheet,.qa__overlay{transition:none!important}}';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function ensurePopup() {
    var el = document.getElementById('QuickAddPopup');
    if (el) return el;
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    el = document.createElement('div');
    el.id = 'QuickAddPopup'; el.className = 'qa';
    el.innerHTML = '<div class="qa__overlay" data-qa-close></div>' +
      '<div class="qa__sheet" role="dialog" aria-modal="true"><div class="qa__handle"></div>' +
      '<button type="button" class="qa__close" data-qa-close aria-label="Close">×</button><div class="qa__body"></div></div>';
    document.body.appendChild(el);
    bindDrag(el.querySelector('.qa__sheet'));
    return el;
  }

  function findVariant() {
    return current.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
  }

  function build() {
    var html = '<div class="qa__head"><div class="qa__imgwrap"><img class="qa__img" src="' + esc(current.image || '') + '" alt=""></div><h3>' + esc(current.title) + '</h3></div>';
    current.options.forEach(function (opt, i) {
      html += '<div class="qa__opt" data-opt="' + i + '"><p>' + esc(opt.name) + ': <b class="qa__sel">' + esc(selected[i]) + '</b></p><div class="qa__vals">';
      opt.values.forEach(function (val) {
        var v = current.variants.find(function (x) { return x.options[i] === val; });
        var isColor = /colou?r|kleur|farbe/i.test(opt.name) && v && v.image;
        html += '<button type="button" class="qa__val' + (isColor ? ' is-img' : '') + '" data-i="' + i + '" data-v="' + esc(val) + '" title="' + esc(val) + '">' +
          (isColor ? '<img src="' + esc(v.image) + '" alt="">' : esc(val)) + '</button>';
      });
      html += '</div></div>';
    });
    html += '<button type="button" class="qa__buy"></button>';
    ensurePopup().querySelector('.qa__body').innerHTML = html;
    update(true);
  }

  // Poora popup dobara nahi banta, sirf zaroori hissa update hota hai (smooth)
  function update(initial) {
    var root = ensurePopup();
    root.querySelectorAll('.qa__val').forEach(function (b) {
      b.classList.toggle('is-active', selected[+b.dataset.i] === b.dataset.v);
    });
    root.querySelectorAll('.qa__opt').forEach(function (o) {
      o.querySelector('.qa__sel').textContent = selected[+o.dataset.opt];
    });
    var v = findVariant();
    var buy = root.querySelector('.qa__buy');
    if (!buy.classList.contains('is-loading') && !buy.classList.contains('is-done')) {
      buy.disabled = !(v && v.available);
      buy.textContent = v && v.available ? 'ADD TO CART  -  ' + v.price : 'SOLD OUT';
    }
    var img = root.querySelector('.qa__img');
    if (v && v.image && !initial && img.getAttribute('src') !== v.image) {
      img.classList.add('is-fade');
      setTimeout(function () { img.src = v.image; img.classList.remove('is-fade'); }, 180);
    }
  }

  function open(p) {
    if (closing) return;
    current = p;
    var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    selected = first.options.slice();
    var el = ensurePopup();
    build();
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
  }

  function close() {
    var el = document.getElementById('QuickAddPopup');
    if (!el || !el.classList.contains('is-open')) return;
    closing = true;
    var sheet = el.querySelector('.qa__sheet');
    sheet.style.transform = '';
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { closing = false; }, 350);
  }

  // Mobile: neeche swipe karke band karo
  function bindDrag(sheet) {
    var startY = 0, dy = 0, dragging = false;
    sheet.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 750 || sheet.scrollTop > 0) return;
      startY = e.touches[0].clientY; dy = 0; dragging = true;
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dy = e.touches[0].clientY - startY;
      if (dy > 0) { sheet.classList.add('is-dragging'); sheet.style.transform = 'translateY(' + dy + 'px)'; }
    }, { passive: true });
    sheet.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      sheet.classList.remove('is-dragging');
      if (dy > 110) close(); else sheet.style.transform = '';
      dy = 0;
    });
  }

  async function swap(url, selector, parentSel) {
    try {
      var res = await fetch(url);
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var fresh = doc.querySelector(selector);
      var cur = document.querySelector(parentSel || selector);
      if (fresh && cur) cur.replaceWith(fresh);
    } catch (e) {}
  }

  async function refreshCart() {
    await swap('/?section_id=mini-cart', 'form.mini-cart', 'mini-cart form.mini-cart');
    await swap('/?section_id=header', '#cart-icon-bubble');
    var d = document.querySelector('cart-drawer details');
    if (d && !d.open) { var s = d.querySelector('summary'); if (s) s.click(); }
  }

  async function addToCart(btn) {
    var v = findVariant();
    if (!v || busy) return;
    busy = true;
    btn.classList.add('is-loading');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');
      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      btn.textContent = '✓';
      await new Promise(function (r) { setTimeout(r, 650); });
      close();
      await new Promise(function (r) { setTimeout(r, 250); });
      await refreshCart();
    } catch (e) {
      btn.classList.remove('is-loading');
    }
    btn.classList.remove('is-done');
    busy = false;
    update();
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('add-to-cart');
    if (atc) {
      var wrap = atc.closest('.card-wrapper');
      var script = wrap && wrap.querySelector('script[data-qa-product]');
      if (script) {
        try {
          var p = JSON.parse(script.textContent);
          e.preventDefault();
          e.stopImmediatePropagation();
          open(p);
        } catch (err) {}
        return;
      }
    }
    if (e.target.closest('[data-qa-close]')) return close();
    var val = e.target.closest('.qa__val');
    if (val) { selected[+val.dataset.i] = val.dataset.v; return update(); }
    var buy = e.target.closest('.qa__buy');
    if (buy) addToCart(buy);
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();